import React from "react";
import InternalDrawer from "../../common/InternalDrawer";
import SvgRightCaret from "../../../assets/icons/SvgCaretDown";
import { updateFilter } from "../../../slices/filter";
import { useDispatch } from "react-redux";
import { Checkbox } from "@/components/ui/checkbox";

function CustomCheckBox({ isChecked, label, name, onClick }) {
  return (
    <div className="w-fit items-start flex space-x-2 py-[15px] px-5 transition-transform duration-200 ease-linear hover:scale-105 overflow-hidden">
      <Checkbox
        id={name}
        checked={isChecked}
        onCheckedChange={onClick}
        className=""
      />
      <label htmlFor={name} className="text-base">
        {label}
      </label>
    </div>
  );
}

function CheckboxDrawer({ isOpen, title, checkBoxes, setDrawer }) {
  const dispatch = useDispatch();

  function handleUpdateFilter(key, value) {
    dispatch(updateFilter({ key, value }));
  }
  return (
    <InternalDrawer isOpen={isOpen} rootProps={{ bgColor: "bg-white" }}>
      <div className="flex flex-col py-[15px] bg-full bg-center overflow-y-auto">
        <div
          className="px-[30px] py-[15px] flex items-center cursor-pointer"
          role="button"
          onClick={() => setDrawer("home")}
        >
          <SvgRightCaret
            style={{
              width: "12px",
              height: "12px",
              transform: "rotate(90deg)",
            }}
          />
          <span className="grow ml-1">{title}</span>
        </div>
        {(checkBoxes || []).map((cb, index) => (
          <CustomCheckBox
            key={index}
            label={cb.title}
            name={cb.name}
            onClick={() => handleUpdateFilter(cb.key, cb.name)}
            isChecked={cb.isSelected}
          />
        ))}
      </div>
    </InternalDrawer>
  );
}

export default React.memo(CheckboxDrawer);
